import React, { Component } from 'react'
import { format, parseISO } from 'date-fns'
import { Text } from '@wework/dieter-ui'
import { withFloorMap } from '@wework/react-floormap'
import { Loader } from 'semantic-ui-react'

const DATE_FORMAT = {
  DATE: 'MMM dd, yyyy',
  datetime: 'MMM dd, yyyy HH:mm (xxx)',
}

interface Props {
  floorMap?: any
  reservation: any
  commitmentsFetchDelay: number
}

interface State {
  loading: boolean
  error: boolean
  commitments: { startDate: string; endDate: string } | []
}

class CommitmentDates extends Component<Props, State> {
  public static defaultProps: Props = {
    floorMap: {},
    commitmentsFetchDelay: 0,
    reservation: {},
  }

  state = {
    loading: true,
    error: false,
    commitments: {
      startDate: '',
      endDate: '',
    },
  }

  timeoutId: any

  componentDidMount() {
    const companyId = this.props.reservation?.account?.uuid
    const reservationId = this.props.reservation?.uuid

    if (companyId && reservationId) {
      this.fetchAfter(
        companyId,
        reservationId,
        this.props.commitmentsFetchDelay
      )
    }
  }

  fetchAfter = (
    companyId: string,
    reservationId: string,
    timeout: number
  ): void => {
    this.timeoutId = setTimeout(() => {
      this.fetchCommitments(companyId, reservationId)
    }, timeout)
  }

  componentDidUpdate(prevProps) {
    // handle updating of reservable while the component is already opened
    const prevcompanyId = prevProps.reservation?.account?.uuid
    const companyId = this.props.reservation?.account?.uuid

    if (companyId && prevcompanyId !== companyId) {
      const reservationId = this.props.reservation?.uuid()
      this.fetchAfter(
        companyId,
        reservationId,
        this.props.commitmentsFetchDelay
      )
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
    }
  }
  fetchCommitments = async (companyId, reservationId) => {
    const { floorMap } = this.props
    if (!floorMap) {
      this.setState({
        loading: false,
        error: true,
        commitments: [],
      })
      return
    }
    const commitmentExtension = floorMap.getExtension('commitment')
    if (!commitmentExtension) {
      this.setState({
        loading: false,
        error: true,
        commitments: [],
      })
      return
    }

    this.setState({
      loading: true,
      error: false,
      commitments: [],
    })

    try {
      const commitments = await commitmentExtension.getCommitments(
        companyId,
        reservationId
      )
      const currentUUID = this.props.reservation?.account?.uuid
      if (currentUUID !== companyId) {
        return
      }

      if (commitments.length === 0) {
        this.setState({
          loading: false,
          error: true,
          commitments: [],
        })
      } else {
        this.setState({
          loading: false,
          error: false,
          commitments: {
            startDate: commitments.commitment_term_started_on,
            endDate: commitments.commitment_term_ended_on,
          },
        })
      }
    } catch (e) {
      console.error(e)
      this.setState({
        loading: false,
        error: true,
        commitments: [],
      })
    }
  }

  renderCommitments = () => {
    const { reservation } = this.props
    const { commitments, loading } = this.state

    if (!reservation) {
      return null
    }

    return (
      <>
        {loading ? (
          <div>
            <Text size="tiny" style={{ fontWeight: '600', marginTop: 18 }}>
              Commitment
            </Text>
            <Loader
              active
              size="tiny"
              style={{ position: 'relative', marginTop: 6 }}
            />
          </div>
        ) : (
          <>
            {commitments.startDate && commitments.endDate && (
              <>
                <Text size="tiny" style={{ fontWeight: '600', marginTop: 18 }}>
                  Commitment
                </Text>
                <Text size="tiny">
                  {' '}
                  {format(
                    parseISO(commitments.startDate),
                    DATE_FORMAT.DATE
                  )} - {format(parseISO(commitments.endDate), DATE_FORMAT.DATE)}
                </Text>
              </>
            )}
          </>
        )}
      </>
    )
  }

  render() {
    return <>{this.renderCommitments()}</>
  }
}

export default withFloorMap()(CommitmentDates)
